export class BaseRichTextResolver {
    constructor(defaultParser, parser) {
        this.defaultParser = defaultParser;
        this.parser = parser;
    }
    getParser() {
        if (this.parser) {
            return this.parser;
        }
        return this.defaultParser;
    }
}
//# sourceMappingURL=base-rich-text-resolver.js.map